import { createContext, useCallback, useContext, type ReactNode } from 'react'
import { useModalReload } from '@hooks/useModalReload'

type SupporterReloadContextType = () => void

const SupporterReloadContext = createContext<SupporterReloadContextType | null>(null)

export function SupporterReloadProvider({
  children,
  reloadKeys,
}: {
  children: ReactNode
  reloadKeys: string[]
}) {
  const reload = useModalReload()
  const reloadSupporter = useCallback(() => reload({ only: reloadKeys }), [reload, reloadKeys])

  return <SupporterReloadContext.Provider value={reloadSupporter}>{children}</SupporterReloadContext.Provider>
}

export function useSupporterReload(): () => void {
  const reload = useContext(SupporterReloadContext)
  if (!reload) {
    throw new Error('Missing SupporterReloadProvider in the tree')
  }
  return reload
}
